var map = {
	"./2c.png": "583a",
	"./2d.png": "7ab6",
	"./2h.png": "d2cb",
	"./2s.png": "e710",
	"./3c.png": "72dc",
	"./3d.png": "9ac4",
	"./3h.png": "336d",
	"./3s.png": "7784",
	"./4c.png": "bcc9",
	"./4d.png": "1cb6",
	"./4h.png": "52d4",
	"./4s.png": "b387",
	"./5c.png": "aa59",
	"./5d.png": "fdb2",
	"./5h.png": "485cc",
	"./5s.png": "a4e7",
	"./6c.png": "d30d",
	"./6d.png": "313a",
	"./6h.png": "c915",
	"./6s.png": "8d80",
	"./7c.png": "3b5d",
	"./7d.png": "074f",
	"./7h.png": "4e34",
	"./7s.png": "839c",
	"./8c.png": "36b4",
	"./8d.png": "9fb0",
	"./8h.png": "068c",
	"./8s.png": "a7b8",
	"./9c.png": "0c22",
	"./9d.png": "c225",
	"./9h.png": "94e7",
	"./9s.png": "024d",
	"./Ac.png": "9f43",
	"./Ad.png": "9cbe",
	"./Ah.png": "b242",
	"./As.png": "b901",
	"./Jc.png": "d446",
	"./Jd.png": "32df",
	"./Jh.png": "50e3",
	"./Js.png": "be57",
	"./Kc.png": "f293",
	"./Kd.png": "d84b",
	"./Kh.png": "14cc",
	"./Ks.png": "6868",
	"./Qc.png": "784c",
	"./Qd.png": "7531",
	"./Qh.png": "a53c",
	"./Qs.png": "1508",
	"./Tc.png": "5d0b",
	"./Td.png": "6d7c",
	"./Th.png": "649e",
	"./Ts.png": "4f77",
	"./Xc.png": "bf24",
	"./Xd.png": "8f48",
	"./Xs.png": "f6bf",
	"./cardBack.png": "6973"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6501";